var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommsDefaults = function SvgCommsDefaults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "comms_defaults_svg2__a",
    x1: -0.33,
    x2: 174.4,
    y1: 168.22,
    y2: 56.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M40.91 0C28.4 0 18.18 10.21 18.18 22.73v154.55c0 12.51 10.22 22.73 22.73 22.73h45.45c2.51 0 4.55-2.04 4.55-4.55s-2.04-4.55-4.55-4.55H40.91c-7.63 0-13.64-6-13.64-13.64V22.73c0-7.63 6-13.64 13.64-13.64h79.55v31.06c0 7.89 6.5 14.39 14.39 14.39h28.79v68.18c0 2.51 2.04 4.55 4.55 4.55s4.55-2.04 4.55-4.55V50c0-1.12-.41-2.21-1.16-3.05L130.66 1.5c-.87-.96-2.1-1.5-3.39-1.5zm88.64 13.87 28.43 31.59h-23.13c-3.02 0-5.3-2.28-5.3-5.3zM45.46 63.64c-2.51 0-4.55 2.04-4.55 4.55s2.04 4.55 4.55 4.55h54.53c2.51 0 4.55-2.04 4.55-4.55s-2.04-4.55-4.55-4.55zm0 27.27c-2.51 0-4.55 2.04-4.55 4.55s2.04 4.55 4.55 4.55h95.45c2.51 0 4.55-2.04 4.55-4.55s-2.04-4.55-4.55-4.55zm0 27.27c-2.51 0-4.55 2.04-4.55 4.55s2.04 4.55 4.55 4.55H100c2.51 0 4.55-2.04 4.55-4.55s-2.04-4.55-4.55-4.55zm98.08 7.94c-11.04 0-20.09 9.05-20.09 20.1 0 5.37 2.16 10.24 5.63 13.86-13.94 5.72-23.81 19.43-23.81 35.38 0 2.51 2.04 4.55 4.55 4.55s4.55-2.04 4.55-4.55c0-16.15 13.01-29.15 29.18-29.15s29.19 13 29.19 29.15c0 2.51 2.04 4.55 4.55 4.55s4.55-2.04 4.55-4.55c0-15.95-9.87-29.66-23.81-35.38 3.47-3.61 5.63-8.49 5.63-13.86 0-11.04-9.05-20.1-20.1-20.1Zm0 9.09c6.13 0 11.01 4.88 11.01 11.01s-4.88 11-11.01 11-11-4.87-11-11 4.87-11.01 11-11.01m-98.08 10.24c-2.51 0-4.55 2.04-4.55 4.55s2.04 4.55 4.55 4.55H100c2.51 0 4.55-2.04 4.55-4.55s-2.04-4.55-4.55-4.55z",
    style: {
      fill: "url(#comms_defaults_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgCommsDefaults;